import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'

import { AccountExpanded } from '@engine/models'

import { Table } from '#components/Table'

interface AccountsListProps {
  accounts: AccountExpanded[]
  selectedId?: string
  onSelect: (account: AccountExpanded) => void
}

const columnHelper = createColumnHelper<AccountExpanded>()

const AccountsList = ({
  accounts,
  selectedId,
  onSelect,
}: AccountsListProps) => {
  const columns = useMemo(
    () => [
      columnHelper.display({
        id: 'accountName',
        header: 'Account Name',
        cell: info => {
          const account = info.row.original
          return (
            <>
              <div className="font-semibold capitalize">{account.name}</div>
              <div className="text-xs opacity-60">{account._id}</div>
            </>
          )
        },
      }),
      columnHelper.accessor('createdAt', {
        id: 'createdAt',
        header: 'Created At',
      }),
      columnHelper.display({
        id: 'tenantName',
        header: 'Tenant',
        cell: info => {
          const account = info.row.original
          return (
            <>
              <div className="font-semibold capitalize">
                {account.tenantName}
              </div>
              <div className="text-xs opacity-60">{account.tenantId}</div>
            </>
          )
        },
      }),
      columnHelper.display({
        id: 'location',
        header: 'City, State',
        cell: info => {
          const account = info.row.original
          return (
            <span className="text-sm">
              {account.city && account.state
                ? `${account.city}, ${account.state}`
                : '-'}
            </span>
          )
        },
      }),
      columnHelper.display({
        id: 'address',
        header: 'Address',
        cell: info => {
          const account = info.row.original
          return (
            <div className="text-sm">
              <div>{account.address || '-'}</div>
              {account.address2 && (
                <div className="text-xs opacity-60">{account.address2}</div>
              )}
            </div>
          )
        },
      }),
    ],
    [],
  )

  return (
    <Table
      data={accounts}
      columns={columns}
      getRowId={account => account._id}
      onRowClick={onSelect}
      selectedId={selectedId}
    />
  )
}

export { AccountsList }
